import { ClientError } from "graphql-request";

import { GraphQLClient } from "graphql-request";
import { getSdk, SdkFunctionWrapper } from "./generated/types";
import { reportUnexpectedError } from "../error-reporter";
import {
  GrafferGqlError,
  GrafferGqlErrors,
  GrafferGqlResult,
} from "./gql-result";
import { GraphQLResponse } from "graphql-request/src/types";

const wrapper: SdkFunctionWrapper = (action, _operationName, _operationType) =>
  action({
    "X-Graffer-GraphQL-Parent-Type": _operationType || "",
    "X-Graffer-GraphQL-API-ID": "pmo28inf75eepg63qxq4ekoeg4",
    "X-Graffer-GraphQL-Query": _operationName,
  });
const graphQLClient = new GraphQLClient(
  "/api/tenant-management/graphql/v1/query",
);
export const gqlClient = getSdk(graphQLClient, wrapper);

function isGqlError(e: Error): e is Omit<ClientError, "response"> & {
  response: Omit<GraphQLResponse, "errors"> & { errors?: GrafferGqlError[] };
} {
  return "response" in e && "request" in e;
}

export const gqlHeader = (parentType: "q" | "m") => ({
  "X-Graffer-GraphQL-Parent-Type": parentType === "q" ? "Query" : "Mutation",
  "X-Graffer-GraphQL-API-ID": "pmo28inf75eepg63qxq4ekoeg4",
});

/**
 * GQLのクエリを実行し、結果をGrafferGqlResultのインスタンスとして返却する
 *
 * クエリの一部において、internal_server_errorが発生した場合には、処理を全て中断する形としている
 * TODO: 部分的に失敗した場合にどのように扱っていくのがベストか検討した上で、よりよいハンドリングは探る
 */
export async function runGqlQueryV2<T>(
  gqlQuery: () => Promise<T>,
): Promise<GrafferGqlResult<T>> {
  try {
    const data = await gqlQuery();
    return new GrafferGqlResult(data, undefined);
  } catch (e) {
    if (isGqlError(e)) {
      // FIXME: graphql-requestの場合、エラーのextensionsが正しく型に含まれていないため型定義ファイルの更新など正しい修正方法を模索する
      const errors = e.response.errors;
      if (
        !Array.isArray(errors) ||
        errors.find((e) => e.extensions?.code === "internal_server_error")
      ) {
        // どこかで内部サーバーエラーが出ている場合は、安全目に倒して、失敗にしておく
        reportUnexpectedError(e);
        throw e;
      }
      return new GrafferGqlResult(
        e.response.data as T | undefined,
        new GrafferGqlErrors(errors, e),
      );
    }
    // No GQL response, could be network error.
    reportUnexpectedError(e);
    throw e;
  }
}

export function findGqlError(
  name: string,
): (e: Error) => GrafferGqlError | undefined {
  return (e: Error) => {
    if (isGqlError(e)) {
      return e.response.errors?.find((e) => e.path?.includes(name));
    }
    return undefined;
  };
}
